import { Question } from './question.model';
export class Lesson{
    id:string
    nameEn:string
    nameKh:string
    order:number
    videoUrl:string
    pdfUrl:string
    disable:boolean = false
    descriptionEn:string
    quiz:Question[]
    instruction:string = ""
    audioUrl:string = ""
    audio:any = null
}